import {urlSiteDeviceConfig} from '../../database/apiUrls'

export function isDCAPRadio(device, prop) {
  return device[prop].toUpperCase().startsWith('F')
}
export function isDCAPRadioId(deviceId) {
  return deviceId ? deviceId.startsWith('F') : false
}
export function isRepeaterRadio(device, prop) {
  return device[prop].toUpperCase().startsWith('E') || device?.type === 'RPMT'
}
export function filterRPMT (arrDevice) {
  return arrDevice.filter (i => i?.type === 'RPMT')
}
export function isTransceiverRadio (device, prop) {
  return (isRepeaterRadio(device, prop) || isDCAPRadio(device, prop))
}
export async function fetchMdtConfig (ss, siteId, deviceId) {
  const cfg = await ss.apiData(urlSiteDeviceConfig(siteId, deviceId))
  return cfg?.data
}